import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=4c1ffe3c&scoped=true"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"
import style0 from "./Web.vue?vue&type=style&index=0&id=4c1ffe3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ffe3c",
  null
  
)

export default component.exports